import React, { Fragment } from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import { ReservedSavedAddressType } from "@mapmycustomers/shared/enum/SavedAddressType";
import { ButtonLink, LoadingSpinner } from "@mapmycustomers/ui";

import GlobalSearchItem from "@app/types/globalSearch/GlobalSearchItem";

import GlobalSearchSectionKey from "../../enum/GlobalSearchSectionKey";
import { isAddressGlobalSearchItem } from "../../util/assert";
import { GlobalSearchSection } from "../../util/buildGlobalSearchSections";
import Item from "../Item";

import messages, { setModeCancelMessage, setModeHints, setModeTitles } from "./messages";
import styles from "./ResultList.module.scss";

export interface ResultListProps {
  loading: boolean;
  onClick: (item: GlobalSearchItem) => void;
  onSetModeCancel: () => void;
  onSetSelected: (index: number) => void;
  sections: GlobalSearchSection[];
  selectedIndex: number;
  setModeType?: ReservedSavedAddressType;
}

const ResultList = ({
  loading,
  onClick,
  onSetModeCancel,
  onSetSelected,
  sections,
  selectedIndex,
  setModeType,
}: ResultListProps) => {
  const intl = useIntl();
  let offset = 0;

  const renderHeading = (key: GlobalSearchSectionKey) => {
    if (key === GlobalSearchSectionKey.RECORDS) {
      return null;
    }
    if (key === GlobalSearchSectionKey.SET_MODE) {
      return setModeType ? (
        <>
          <div className={cn(styles.heading, styles.setModeHeading)}>
            {intl.formatMessage(setModeTitles[setModeType])}
            <ButtonLink onClick={onSetModeCancel}>
              {intl.formatMessage(setModeCancelMessage)}
            </ButtonLink>
          </div>
          <div className={styles.hint}>{intl.formatMessage(setModeHints[setModeType])}</div>
        </>
      ) : null;
    }
    return <div className={styles.heading}>{intl.formatMessage(messages[key])}</div>;
  };

  return (
    <>
      {sections.map(({ items, key }) => {
        const start = offset;
        offset += items.length;
        const fetched =
          key === GlobalSearchSectionKey.RECORDS || key === GlobalSearchSectionKey.RECENT;
        return (
          <Fragment key={key}>
            {renderHeading(key)}
            {loading && fetched ? (
              <LoadingSpinner />
            ) : (
              items.map((item, i) => (
                <Item
                  index={start + i}
                  isSelected={selectedIndex === start + i}
                  item={item}
                  key={isAddressGlobalSearchItem(item) ? item.prediction.place_id : start + i}
                  onClick={onClick}
                  onSetSelected={onSetSelected}
                />
              ))
            )}
          </Fragment>
        );
      })}
    </>
  );
};

export default ResultList;
